<template>
  <el-form-item
    :label="label"
    class="flight-purpose-code"
    :prop="prop"
    :rules="rules"
  >
    <el-select
      v-model="flightPurposeCode"
      :placeholder="placeholder"
      :disabled="disabled"
      :autofocus="autofocus"
      :clearable="false"
      :filterable="false"
      :filter-method="filter"
    >
      <el-option label="" value="" />
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.value"
        :value="item.value"
      >
        <span style="float: left; color: #8492a6; font-size: 13px">{{item.value}}</span>
        <span style="float: left; margin-left: 10px">{{item.label}}</span>
      </el-option>
    </el-select>
  </el-form-item>
</template>

<script>
import Validator from '@/mixins/Validator.vue'

export default {
  components: {},
  model: {
    event: 'change'
  },
  mixins: [
    Validator
  ],
  props: {
    value: String,
    label: {
      type: String,
      default: '飛行目的'
    },
    placeholder: {
      type: String,
      default: ''
    },
    prop: {
      type: String,
      default: 'flight_purpose_code'
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    initialize: {
      type: Boolean,
      default: false
    },
    searchCond: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      options: [],
      optionsOriginal: []
    }
  },
  computed: {
    flightPurposeCode: {
      get () {
        return this.value
      },
      set (flightPurposeCode) {
        this.$emit('change', flightPurposeCode)
        this.options = this.optionsOriginal
      }
    },
    rules: {
      get () {
        const rules = []
        if (!this.disabled) {
          if (this.required) {
            rules.push(this.validatorRequired(this.label, 'change'))
          }
        }
        return rules
      }
    }
  },
  async mounted () {
    const flightPurposeCode = await this.loadCode()
    const flightPurposeCodeSet = flightPurposeCode.map(function (index, array) {
      return { value: index.code_value, label: index.code_explanation }
    })
    this.options = flightPurposeCodeSet
    this.optionsOriginal = flightPurposeCodeSet
  },
  methods: {
    async loadCode () {
      if (this.initialize) {
        await this.$axios
          .get('/code-master', { params: { code_id: 'FLIGHT_PURPOSE_CODE' } })
          .then((res) => {
            sessionStorage.setItem('flightPurposeCode', JSON.stringify(res.data.list))
          })
          .catch((e) => {
            console.log(e)
          })
      }
      return JSON.parse(sessionStorage.getItem('flightPurposeCode'))
    },
    filter (a) {
      this.options = this.optionsOriginal.filter((x) => {
        return x.value.toLowerCase().indexOf(a.toLowerCase()) === 0 || x.label.toLowerCase().indexOf(a.toLowerCase()) === 0
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.flight-purpose-code {
  ::v-deep .el-form-item__content {
    width: 12em;
  }
}
</style>
